import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

class CausePrincipaleSelect extends React.Component {
    render() {
        const { value, onChange, causesPrincipales } = this.props;


        let selected = value;
        if (causesPrincipales.length === 0 || value === 0) {
            selected = '';
        }

        return (
            causesPrincipales && (
                <TextField
                    select
                    required
                    name="causePrincipaleId"
                    label="Cause principale"
                    value={selected}
                    onChange={onChange}
                    fullWidth
                >
                {
                    causesPrincipales.map(type => (
                        <MenuItem key={type.id} value={type.id}>
                            {type.libelle}
                        </MenuItem>
                        ))
                }
                </TextField >
            )
        );
    }
}

CausePrincipaleSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    causesPrincipales: PropTypes.array
};

export default CausePrincipaleSelect;